import { Input, Card, Radio, Button, Modal, Tag } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import Draggable from "react-draggable";

import { TableHelper } from "../../util/TableHelper";
import { ParkingRequestTypeConstant } from "../../constants/DatabaseConstants/ParkingConstants";
import Loading from "../common/Loading";
import useScheduleList from "./index.hook";
import LocalStorageUtil from "../../util/LocalStorageUtil";
import { LocalStorageConstants } from "../../constants/ApplicationConstants/LocalStorageConstants";

import Authentication from "../../util/Authentication";
import { Modules, Operations } from "../../constants/DatabaseConstants/MasterConstant";
import { useReactDraggable } from "../../hooks/useReactDraggable";

import type { UserInterface } from "../../shared/interface/auth/User.interface";
import type { GetScheduleList } from "../../shared/interface/parking.interface";

const DisplayScheduleList = () => {
  /* CONSTANT */
  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  const config = useScheduleList();

  /* HOOK */
  const { bounds, onStart } = useReactDraggable();

  const renderText = (text: string | number) => {
    return <div className="wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
  };

  const renderNumberValue = (text: string | number) => {
    return <div className="gx-text-right">{TableHelper.getValue(text)}</div>;
  };

  const columns: ColumnsType<GetScheduleList> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Username",
      dataIndex: "user_name",
      key: "user_name",
      render: (text, record) => <div className={record?.id === config.recordID?.id ? `wordWrapWordBreak gx-link entity-name-selected` : `wordWrapWordBreak`}>{TableHelper.getValue(text)}</div>,
      sorter: {
        compare: TableHelper.valueCompare("user_name")
      }
    },
    {
      align: "left",
      title: "KeyFob",
      key: "key_fob_display_value",
      dataIndex: "key_fob_display_value",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("key_fob")
      }
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("location")
      }
    },
    {
      align: "left",
      title: "Client",
      dataIndex: "client",
      key: "client",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("client")
      }
    },
    {
      align: "left",
      title: "Scheduled Date-Time",
      dataIndex: "scheduled_date_time",
      key: "scheduled_date_time",
      render: renderNumberValue,
      sorter: {
        compare: TableHelper.dateSorter("scheduled_date_time")
      }
    },
    {
      align: "left",
      title: "Booking Date-Time",
      dataIndex: "created_on",
      key: "created_on",
      render: renderNumberValue,
      sorter: {
        compare: TableHelper.dateSorter("created_on")
      }
    },
    {
      align: "center",
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return record?.is_confirmed ? (
          <Tag className="gx-text-center gx-m-0" color="green">
            {text ?? ""}
          </Tag>
        ) : (
          <span></span>
        );
      },
      sorter: {
        compare: TableHelper.valueCompare("status")
      },
      width: "10%"
    },
    {
      align: "left",
      title: "Action",
      fixed: "right",
      render: (text, record) => (
        <div>
          {Authentication.hasModuleAndOperationAccess(userData, Modules.SCHEDULE_LIST, Operations.DELETE) && (
            <Button onClick={() => config.handleCancel(record)} className="gx-mb-0 button-gradiant">
              Cancel
            </Button>
          )}
        </div>
      )
    }
  ];

  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={`gx-title-container`}>
          <Radio.Group onChange={(e) => config.handleModeChange(e.target.value)} value={config.mode}>
            <Radio.Button style={{ fontSize: "18px" }} value={ParkingRequestTypeConstant.RETRIEVAL}>
              Retrieval
            </Radio.Button>
            <Radio.Button style={{ fontSize: "18px" }} value={ParkingRequestTypeConstant.BOOKING}>
              Booking
            </Radio.Button>
          </Radio.Group>
          <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} value={config.searchedText} onChange={(e) => config.handleChangeSearch(e.target.value)} onSearch={config.handleChangeOnSearch} />
        </div>
      }
    >
      {config.loading && <Loading />}

      {!config.loading && Authentication.hasModuleAndOperationAccess(userData, Modules.SCHEDULE_LIST, Operations.READ) && <Table className="gx-table-responsive" size="small" columns={columns} dataSource={config.scheduleList} pagination={config?.pagination} bordered onChange={config.handleChangePagination} rowKey={(record) => record.sr_no} />}

      <Modal
        title={<div className="modal-container">{"Cancel Confirmation"}</div>}
        open={config.isModalOpen}
        onOk={config.handleOk}
        onCancel={config.handleCancelModal}
        okText="Yes"
        cancelText="No"
        width="500px"
        wrapClassName="delete-modal"
        maskClosable={false}
        modalRender={(modal) => (
          <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
            {modal}
          </Draggable>
        )}
        okButtonProps={{
          disabled: config?.saving,
          loading: config?.saving
        }}
      >
        <p>
          Are you sure you want to cancel the Scheduled request for user <span className="gx-link entity-name-selected">{config?.recordID?.user_name}?</span>
        </p>
      </Modal>
    </Card>
  );
};
export default DisplayScheduleList;
